import { Modal, Typography, Space, Divider, Button, Tag, Flex } from "antd";
import React, { useEffect, useState, useRef } from "react";
import { useDispatch } from "react-redux";
import {
  actionsApi,
  LLFormat,
  convertTo12HourFormat,
  formatCurrency,
  recipentAreaLookup,
  treatmentTypeLookup,
  FormatDateTimeFun,
  toCapitalize,
  formatLabel,
  utcDateTimeToLocalPA,
  formatCompactAmount,
} from "../../shared";
import { HairLossStage } from "../../components";
import { CitiesTag } from "../utils";
import { Addappointment } from "../../components";
import "./index.css";
import { ReadyToPrint } from "../Printer/ReadyToPrint";
import { PrinterOutlined } from "@ant-design/icons";
import moment from "moment";
import { can } from "../../Auth";
const { Title, Text } = Typography;

const View = ({ data }) => {
  const ref = React.createRef();
  const [state, setState] = useState(null);
  useEffect(() => {
    if (data) {
      setState({
        ...data,
      });
    }
  }, [data]);
  return (
    <div ref={ref} className="print-fue-appointment-detail">
      <header></header>
      <div direction="vertical">
        <Space className="detail-row">
          <Text strong>Client Name:</Text>
          <Text>{state?.appointment?.client_info?.name}</Text>
        </Space>
        <Divider />
        <Space className="detail-row">
          <Text strong>Father Name:</Text>
          <Text>{state?.appointment?.client_info?.fatherName}</Text>
        </Space>
        <Divider />
        <Space className="detail-row">
          <Text strong>Age:</Text>
          <Text>{state?.appointment?.client_info?.age} Years</Text>
        </Space>
        <Divider />
        <Space className="detail-row">
          <Text strong>Cnic No:</Text>
          <Text>{state?.appointment?.client_info?.cnic_passport}</Text>
        </Space>
        <Divider />
        <Space className="detail-row">
          <Text strong>Session Time:</Text>
          <Text>{utcDateTimeToLocalPA(state?.sessionDateTime)}</Text>
        </Space>
        <Divider />
        <Space className="detail-row">
          <Text strong>Issues:</Text>
          <Flex gap={5} justify="space-between">
            {state?.appointment?.client_info?.medical_info
              ? Object.entries(state?.appointment?.client_info.medical_info)
                  .filter(
                    ([key, value]) => key.startsWith("is") && value === "1",
                  )
                  .slice(0, 5) // Only show first 5 issues
                  .map(([key, value], i) => (
                    <Tag className="m-0" key={i}>
                      {formatLabel(key)}
                    </Tag>
                  ))
              : "-"}
          </Flex>
        </Space>
        <Divider />
        <Space className="detail-row">
          <Text strong>Telephone:</Text>
          <Text>
            {state?.appointment?.client_info?.countryCode}{" "}
            {state?.appointment?.client_info?.telephone}
          </Text>
        </Space>
        <Divider />
        <Space className="detail-row">
          <Text strong>Registration:</Text>
          <Text>
            {moment(state?.appointment?.client_info?.register_date).format(
              "MMM Do YYYY",
            )}
          </Text>
        </Space>
        <Divider />

        <Space className="detail-row">
          <Text strong>Occupation:</Text>
          <Text>{state?.appointment?.client_info?.occuption}</Text>
        </Space>
        <Divider />
        <Space className="detail-row">
          <Text strong>Source of Information:</Text>
          <Text>{state?.appointment?.client_info?.other_source}</Text>
        </Space>
        <Divider />
        {can("Session", "view payment details") && (
          <Space className="detail-row">
            <Space>
              <Text strong>Total Amount:</Text>
              <Text>
                {formatCompactAmount(state?.appointment?.totalPayment)} (PKR)
              </Text>
            </Space>
            <Space>
              <Text strong>Advance:</Text>
              <Text>
                {formatCompactAmount(state?.appointment?.advancePayment)} (PKR)
              </Text>
            </Space>
            <Space>
              <Text strong>Remaining:</Text>
              <Text>
                {formatCompactAmount(state?.appointment?.duePayment)} (PKR)
              </Text>
            </Space>
          </Space>
        )}
      </div>
    </div>
  );
};

const PrintForm = ({ state }) => {
  return <View data={state} />;
};

const ViewFUEAppointment = ({ visible, data, isDashboardFUE, onClose }) => {
  const print = useRef();
  const dispatch = useDispatch();

  const [visibleAppointmentModal, setVisibleAppointmentModal] = useState(false);
  const [row, setRow] = useState(null);
  const [editID, setEditID] = useState(null);
  const editAppointment = () => {
    onClose();
    setRow({ ...data?.Client_info });
    setEditID(data?.id);
    dispatch(
      actionsApi?.setSteps({
        ...data,
        client_id: data?.Client_info?.id,
        stage: parseInt(data?.stage),
        clientPriority: parseInt(data?.clientPriority?.id),
      }),
    );
    setVisibleAppointmentModal(true);
  };

  const clickOnPrint = () => {
    if (print.current) {
      print.current();
    }
  };
  return (
    <div>
      <Modal
        title={
          <Title level={5} className="my-0">
            {toCapitalize(data?.appointment?.client_info?.name)}'s Appointment
            Details
          </Title>
        }
        centered
        width={800}
        visible={visible}
        onOk={onClose}
        onCancel={onClose}
        footer={
          <Space>
            <Button danger onClick={onClose}>
              Close
            </Button>
            <Button
              style={{ background: "#2F80ED" }}
              className="text-white border-0"
              onClick={clickOnPrint}
              icon={<PrinterOutlined />}
            >
              Print Details
            </Button>
            {/* <Button
              type="primary"
              onClick={editAppointment}
              className="fue-btn"
            >
              Edit FUE
            </Button> */}
          </Space>
        }
      >
        <ReadyToPrint
          name={
            data?.appointment?.client_info?.name + "'s Fue Appointment detail"
          }
          print={print}
          Component={
            <div>
              <PrintForm state={data} />
            </div>
          }
        />
      </Modal>
      {/* <Addappointment
        visible={visibleAppointmentModal}
        clientInfo={row}
        editID={editID}
        onClose={() => {
          setRow(null);
          setVisibleAppointmentModal(false);
          setEditID(null);
        }}
        isFUE
        isDashboardFUE={isDashboardFUE}
      /> */}
    </div>
  );
};
export { ViewFUEAppointment };
